import { axios } from "@app/app/services/axios";
import { queryClient } from "@app/app/services/queryClient";
import { IExtra } from "@app/common/types";
import { QueryKeys } from "@app/room/constants/QueryKeys";
import { ITaxesAndFees } from "@app/room/types";

export const getRoomRateExtras = async (
    propertyId: string | undefined,
    roomId: string | undefined,
    rateId: string | undefined,
    checkin: string,
    checkout: string,
    languageCode: string,
    adultCount = 2,
    childCount = 0,
    infantCount = 0
): Promise<IExtra[]> => {
    const response = await axios.get<any>(
        `/properties/${propertyId}/rooms/${roomId}/extras/${rateId}?ci=${checkin}&co=${checkout}&lg=${languageCode}&ac=${adultCount}&cc=${childCount}&ic=${infantCount}`
    );

    return response.data;
};

export const prefetchTaxAndFees = (
    propertyId: string | undefined,
    roomId: string | undefined,
    rateId: string | undefined,
    checkin: string,
    checkout: string,
    adultCount = 2,
    childCount = 0,
    infantCount = 0,
    promocode: string | undefined
) =>
    queryClient.fetchQuery(
        [QueryKeys.RoomRateTaxes, propertyId, roomId, rateId, checkin, checkout, adultCount, childCount, infantCount, promocode],
        async () => {
            const response = await axios.get<ITaxesAndFees>(`/properties/${propertyId}/rooms/${roomId}/rates/${rateId}/taxes`, {
                params: {
                    check_in: checkin,
                    check_out: checkout,
                    adults: adultCount,
                    children: childCount,
                    infants: infantCount,
                    promocode,
                },
            });

            return response.data;
        },
        {
            staleTime: 1000 * 60 * 10, // 10 minutes
        }
    );
